module.exports = __webpack_public_path__ + "img/bb3.e250e8e8.png";